/// <reference path="../definitions/irep/irep.d.ts" />
/// <reference path="../definitions/pagedown/pagedown.d.ts" />
/// <reference path="../definitions/select2/select2.d.ts" />
/// <reference path="../public/irep.ts" />
/// <reference path="../public/validationcomponent/validationComponent.ts" />
/// <reference path="../public/storePosition/storePosition.ts" />

declare var irep: IREP.IREP;

namespace IREP {

    export interface IStoreManualOptions {
        id: string;
    }

    export class StoreManualEntry extends ValidationComponentV3 {
        private snlCallback: Function;
        private rsnlCallback: Function;
        private searchForm: JQuery;
        private searchBackdrop: JQuery;
        private closeForm: JQuery;
        private searchResults: JQuery;
        private buttonSearch: JQuery;
        private buttonSelect: JQuery;
        private buttonBack: JQuery;
        private buttonFinish: JQuery;
        private searchModal: JQuery;
        private form: JQuery;
        private storeComponent: JQuery;
        private promoterComponent: JQuery;
        private retailerControl: JQuery;
        private countrySearch: JQuery;
        private provinceList: JQuery;
        private provinceContainer: JQuery;
        private recommendedStoreList: JQuery;
        private scrollPosition: number;
        private showRetailer: boolean;

        constructor(options: IStoreManualOptions) {
            super(options.id);
            this.searchResults = this.$component.find("#searchResults2");
            this.recommendedStoreList = this.$component.find(".recommendedStoreList");
            this.searchForm = this.$component.find("#StoreManualEntry");
            this.searchBackdrop = this.$component.find("#SearchBackdrop");
            this.closeForm = this.$component.find("#FormCloseButton");
            this.buttonSearch = this.$component.find("#buttonSearch");
            this.buttonSelect = this.$component.find("#buttonSelect");
            this.buttonBack = this.$component.find("#buttonBack");
            this.buttonFinish = this.$component.find("#buttonFinish");
            this.searchModal = this.$component.find("#SearchModal");
            this.form = this.$component.find("#formValidateStore");
            this.storeComponent = this.$component.find(".manualInfo"); //This form does not perform a postback - it exists for validation purposes. 
            this.promoterComponent = this.$component.find(".promoterInfo"); //This form does not perform a postback - it exists for validation purposes. 
            this.retailerControl = this.$component.find(".retailerControl");
            this.countrySearch = this.$component.find("#StorePositionModel_StoreManualEntryModel_sInfo_Country");
            this.provinceList = this.$component.find("#StorePositionModel_StoreManualEntryModel_sInfo_Province");
            this.provinceContainer = this.$component.find(".stateSelect");

            this.bindEvents();
        }

        public getForm() {
            return this.form;
        }

        //Setting header texts for the search
        public setMode(mode: number) {
            if (mode == StorePosition.PositionMode.RETAILER) {
                $(".retailerText").removeClass("hidden");
                $(".manufacturerText").addClass("hidden");
                this.storeComponent.removeClass('hidden');
                this.promoterComponent.addClass('hidden');
                irep.callApi({ url: "localization/text", type: "GET", data: { id: 211769, cultureCode: irep.options.user.cultureCode } }).done((d) => {
                    $(".storeName").html(d.text);
                });
                irep.callApi({ url: "localization/text", type: "GET", data: { id: 231065, cultureCode: irep.options.user.cultureCode } }).done((d) => {
                    $(".storeNumber").contents().get(0).nodeValue = d.text;
                });
            } else if (mode == StorePosition.PositionMode.MANUFACTURER) {
                $(".retailerText").addClass("hidden");
                $(".manufacturerText").removeClass("hidden");
                this.storeComponent.removeClass('hidden');
                this.promoterComponent.addClass('hidden');
                irep.callApi({ url: "localization/text", type: "GET", data: { id: 231057, cultureCode: irep.options.user.cultureCode } }).done((d) => {
                    $(".storeName").html(d.text);
                });
                irep.callApi({ url: "localization/text", type: "GET", data: { id: 231058, cultureCode: irep.options.user.cultureCode } }).done((d) => {
                    $(".storeNumber").contents().get(0).nodeValue = d.text;
                });
            } else {
                $(".retailerText").addClass("hidden");
                $(".manufacturerText").addClass("hidden");
                this.storeComponent.addClass('hidden');
                this.promoterComponent.removeClass('hidden');
            }
        }

        private bindEvents() {
            this.unbindEvents();

            this.searchModal.on("click", function (evt) { evt.stopPropagation(); }); //Prevent clickthrough on modal causing searchBackdrop.click to fire.
            this.searchBackdrop.on("click", (e) => this.close());
            this.closeForm.on("click", (e) => this.close());
            this.buttonSearch.on("click", (e) => this.attemptMatch());
            this.buttonFinish.on("click", (e) => this.validateForm(true));
            this.buttonSelect.on("click", (e) => this.takeSelection());
            this.buttonBack.on("click", (e) => this.backForm());
            this.countrySearch.on("change", (e) => this.changeCountry(e));
            this.searchResults.on("click", (e) => this.setSelection(e));
            this.searchResults.on("dblclick", (e) => this.takeSelection());
        }

        private unbindEvents() {
            this.searchModal.unbind('click');
            this.searchBackdrop.unbind('click');
            this.closeForm.unbind('click');
            this.buttonSearch.unbind('click');
            this.buttonFinish.unbind('click');
            this.buttonSelect.unbind('click');
            this.buttonBack.unbind('click');
            this.countrySearch.unbind('change');
            this.searchResults.unbind('click');
            this.searchResults.unbind('dblclick');
        }

        private setSelection(e: JQueryEventObject) {
            if (e.target.localName == "li") {
                $("li.selected").removeClass('selected'); //Clear previous selections
                $(e.target).addClass('selected'); //Select current item. 
            }
        }

        private takeSelection() {
            var storeId = this.searchResults.children('.selected').attr('data-value');
            if (storeId != null && storeId != "") {
                this.close();
                if (this.retailerControl.hasClass('hidden')) {
                    this.snlCallback(storeId);
                } else {
                    this.rsnlCallback(this.searchResults.children('.selected').attr('data-storeChainId'), storeId);
                }
            }
        }

        private backForm() {
            this.recommendedStoreList.addClass('hidden');
            this.buttonSelect.addClass('hidden');
            this.buttonBack.addClass('hidden');
            this.buttonFinish.addClass('hidden');
            $(".enteredStore").addClass('hidden');
            $(".addressField").removeClass('hidden');
            $("#buttonSearch").removeClass('hidden');

            this.handleRetailer();
        }

        private attemptMatch() {
            if (!this.validateForm(false)) {
                return false;
            }

            var retailerName = $("#StorePositionModel_Info_StoreChainId :selected").text();
            if (!this.retailerControl.hasClass('hidden')) {
                retailerName = $("#StorePositionModel_StoreManualEntryModel_sInfo_RetailerName").val();
            }

            var qq = this;
            $.ajax({
                type: "get",
                dataType: "json",
                url: irep.options.appUrl + "FindPossibleMatches",
                data: {
                    retailerName: retailerName,
                    site: 0,
                    storeChainId: null,
                    storeName: $("#StorePositionModel_StoreManualEntryModel_sInfo_StoreName").val(),
                    storeNumber: $("#StorePositionModel_StoreManualEntryModel_sInfo_StoreNumber").val(),
                    address: $("#StorePositionModel_StoreManualEntryModel_sInfo_Address").val(),
                    city: $("#StorePositionModel_StoreManualEntryModel_sInfo_City").val(),
                    province: $("#StorePositionModel_StoreManualEntryModel_sInfo_Province :selected").text(),
                    postalCode: $("#StorePositionModel_StoreManualEntryModel_sInfo_PostalCode").val(),
                    countryCode: this.countrySearch.val()
                }
            }).done(function (d) {
                if (d == null || d.Data == null || d.Data.length == 0) {
                    qq.validateForm(true);
                }
                else {
                    var listItems = "";

                    for (var i = 0; i < d.Data.length; i++) {
                        listItems += "<li data-storeChainId='" + d.Data[i].StoreChainId + "' data-value='" + d.Data[i].Id + "'>" + d.Data[i].Name + "</li>";
                    }
                    qq.searchResults.html(listItems);

                    qq.recommendedStoreList.removeClass('hidden');
                    qq.buttonSelect.removeClass('hidden');
                    qq.buttonBack.removeClass('hidden');
                    qq.buttonFinish.removeClass('hidden');

                    $("#retailerInput").html(retailerName);
                    $("#storeNameInput").html($("#StorePositionModel_StoreManualEntryModel_sInfo_StoreName").val());
                    $("#storeNumberInput").html($("#StorePositionModel_StoreManualEntryModel_sInfo_StoreNumber").val());
                    $("#addressInput").html($("#StorePositionModel_StoreManualEntryModel_sInfo_Address").val());
                    $("#cityInput").html($("#StorePositionModel_StoreManualEntryModel_sInfo_City").val());
                    $("#provinceInput").html($("#StorePositionModel_StoreManualEntryModel_sInfo_Province :selected").text());
                    $("#postalCodeInput").html($("#StorePositionModel_StoreManualEntryModel_sInfo_PostalCode").val());

                    $(".enteredStore").removeClass('hidden');
                    $(".addressField").addClass('hidden');
                    $("#buttonSearch").addClass('hidden');
                }
            });
        }

        //Call this before opening the form. Set the callback functions for this form, so you can get the store and retailer not selected results if needed. 
        public setCallback(snlCallback: (storeId: number) => any, rsnlCallback: (retailerId: number, storeId: number) => any) {
            this.snlCallback = snlCallback;
            this.rsnlCallback = rsnlCallback;
        }

        private handleRetailer() {
            if (this.showRetailer) {
                this.retailerControl.addClass('required');
                this.retailerControl.removeClass("hidden");
            } else {
                this.retailerControl.removeClass('required');
                this.retailerControl.addClass("hidden");
                this.retailerControl.val(''); 
            }

        }

        //Call this top open this form for the user.  
        public open(showRetailer: boolean) {
            this.backForm();
            this.searchForm.removeClass('hidden');
            this.showRetailer = showRetailer;
            this.handleRetailer();

            //Before you open the modal, determine the current position on the screen. 
            //You need to do position: fixed on mobile, but that resets the screen position to zero, so we need to save the position. 
            //On desktop you're not able to scroll at all, so you're only scrolling to the current position. 
            this.scrollPosition = $("body").scrollTop();
            $("body").addClass("modal-open");  //Tell the form that the modal is open, to prevent scrolling.
        }

        private close() {
            this.searchForm.addClass('hidden');
            $("body").removeClass("modal-open"); //Allow scrolling again.
            $("body").scrollTop(this.scrollPosition); //Scroll back to the original position. 
        }

        //Update the list of available provinces in the geo.
        public updateProvinces(countryCode: string) {
            if (countryCode == null) return; /* initialization bug */
            var qq = this;
            $.ajax({
                type: "get",
                dataType: "json",
                url: irep.options.appUrl + "ProvinceList",
                data: { countryCode: countryCode }
            }).done(function (d) {
                if (d.Provinces.length == 0) {
                    //If no provinces available, hide the province dropdown and remove the requirement.
                    qq.provinceList.closest('.has-error').removeClass('has-error');
                    qq.provinceList.removeAttr('required');
                    qq.provinceContainer.addClass('hidden');
                } else {
                    //We have provinces, make sure the province list is visible and that we are required. 
                    qq.provinceList.attr('required', 'required');
                    qq.provinceContainer.removeClass('hidden');
                    var listItems = "<option></option>";
                    for (var i = 0; i < d.Provinces.length; i++) {
                        listItems += "<option value='" + d.Provinces[i].Id + "'>" + d.Provinces[i].Name + "</option>";
                    }
                    qq.provinceList.html(listItems);
                }
                qq.provinceList.val(null).trigger('change'); //Remove any previously selected province.
            });
        }

        //When the country is changed on the parent form, set the country on this form, and trigger a change so the below 'ChangeCountry' function is called. 
        public setCountry(countryCode: string, trigger: boolean) {
            if (trigger) {
                this.countrySearch.val(countryCode).trigger('change');
            }
            else {
                this.countrySearch.val(countryCode);
            }
        }

        //When the country is changed, update the province list. 
        private changeCountry(e: JQueryEventObject) {
            this.updateProvinces(this.countrySearch.val());
            e.preventDefault();
        }

        public isValid(checkRetailer: boolean) {
            if (checkRetailer && $("#StorePositionModel_StoreManualEntryModel_sInfo_RetailerName").val().trim() == "") return false; 

            return ($("#StorePositionModel_StoreManualEntryModel_sInfo_StoreName").val().trim() != "" && 
                $("#StorePositionModel_StoreManualEntryModel_sInfo_Address").val().trim() != "" && 
                $("#StorePositionModel_StoreManualEntryModel_sInfo_City").val().trim() != "" )
        }

        //Validate and close the form if valid. 
        public validateForm(executeCallbacks: boolean) {
            this.bindValidation(this.form, false);
            if (this.form.valid()) {
                if (executeCallbacks) {
                    //Perform callback to the storePosition control.
                    if (!this.showRetailer) {
                        this.snlCallback(0);
                    } else {
                        this.rsnlCallback(0, 0);
                    }
                    this.close();
                }
                return true;
            }
            return false;
        }

    }
}